<template>
    <div class="outdated-container">
        <div v-for="(item, index) of products" :key="item._id">
            <router-link :to="{ name: 'admin_products_variant', params: { id: item._id }}">
                <h2>{{ item.name }}</h2>
            </router-link>
            <p>Marketplace la plus ancienne: {{ getLastModif(index) }}</p>
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "AdminBrandsOutdated",
        created() {
            this.getOutdated().then(data => {
                this.products = data.data.products
            })
        },
        data() {
            return {
                products: {}
            }
        },
        methods: {
            ...mapActions('brand', ['getOutdated']),

            getLastModif(pos) {
                var date = "";
                for (var i = 0; i < this.products[pos].marketplaces.length; i++) {
                    if (date == "") {
                        date = this.products[pos].marketplaces[i].lastModif;
                    } else {
                        if (this.products[pos].marketplaces[i].lastModif < date) date = this.products[pos].marketplaces[i].lastModif;
                    }
                }
                if (date == "" || date == null) date = "pas de date disponible";

                return date;
            }
        }
    }
</script>

<style scoped lang="scss">
    .outdated-container{
        display: flex;
        flex-wrap: wrap;
        padding: 0 20px 0 40px;
        justify-content: space-around;

        & > div {
            width: 300px;
            border: 1px solid #000;
            border-radius: 5px;
            margin: 5px;
            padding: 10px;
            text-align: center;

            a {
                text-decoration: none;
                color: #000;

                h2 {
                    font-weight: 700;
                    font-size: 16px;
                }
            }
        }
    }
</style>
